import { captureEvent } from "@/app/_analytics/analytics";
import { usePostHogState } from "@/app/_providers/posthog";
import { EventName } from "@mw/shared/analyticsEventNames";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";

export const useCapturePageViews = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const isPostHogLoaded = usePostHogState(state => state.isLoaded);
  const previousUrl = useRef<string | null>(null);

  useEffect(() => {
    if (!pathname || !isPostHogLoaded) return;

    let url = window.origin + pathname;
    if (searchParams && searchParams.toString()) {
      url = url + `?${searchParams.toString()}`;
    }

    if (previousUrl.current) {
      captureEvent(EventName.$pageleave, { $current_url: previousUrl.current });
    }

    captureEvent(EventName.$pageview, { $current_url: url });
    previousUrl.current = url;
  }, [pathname, searchParams, isPostHogLoaded]);
};
